// extracted by mini-css-extract-plugin
module.exports = {"scrollingTextWrapper":"style_scrollingTextWrapper__1_mnX","scroll-text":"style_scroll-text__1L3YE"};